/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Lines_TabInputs */

const fr_network_lines_tab = /** @type {(inputs: Network_Lines_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes`)
};

const en_network_lines_tab = /** @type {(inputs: Network_Lines_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines`)
};

/**
* | output |
* | --- |
* | "Lines" |
*
* @param {Network_Lines_TabInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_lines_tab = /** @type {((inputs?: Network_Lines_TabInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Lines_TabInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_lines_tab(inputs)
	return en_network_lines_tab(inputs)
});